import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import moment from 'moment';

import { RequestResult } from '@api/responseModels/requestResult';
import { ScheduleResp } from '@api/responseModels/worker/schedule/scheduleResponse';
import { CRMAPIManager } from '@classes/crmApiManager';

import { TSchedule, TScheduleCreateOwner } from '../common/types';
import { TState } from '../schedule';

export function useCreateSchedule({
    state,
    crmID,
    workerPositionID,
    wpMode,
    messageApi,
    validateSchedule,
}: {
    state: TState;
    crmID: number | string;
    workerPositionID: number | string;
    wpMode: boolean;
    messageApi: any;
    validateSchedule: () => boolean;
}) {
    const navigate = useNavigate();

    const createSchedule = useCallback(async () => {
        if (!validateSchedule()) return;

        state.isLoading = true;
        try {
            const result: RequestResult<ScheduleResp> = await CRMAPIManager.request(
                async (api) => {
                    const ts = state.schedule as TSchedule;
                    const startAt = moment(ts.start_schedule_at, 'YYYY-MM-DD');
                    const owner: TScheduleCreateOwner = wpMode
                        ? { owner_type: 'worker-position', owner_id: +workerPositionID }
                        : { owner_type: 'crm', owner_id: +crmID };

                    return await api.saveSchedule(owner, {
                        title: ts.title,
                        start_time: ts.start_time,
                        end_time: ts.end_time,
                        breaks: ts.breaks,
                        day_offs: ts.day_offs,
                        schedule_days: ts.schedule_days,
                        schedule_type: ts.schedule_type,
                        start_schedule_at: startAt.isAfter(moment(), 'day')
                            ? ts.start_schedule_at
                            : moment().add(2, 'day').format('YYYY-MM-DD'),
                    });
                }
            );

            if (result.errorCode) throw result;

            messageApi.success('График создан');
            navigate(
                wpMode
                    ? `/lk/worker/crm/${crmID}/workers/${workerPositionID}/schedule`
                    : `/lk/worker/crm/${crmID}/schedule`
            );
        } catch (err) {
            messageApi.error('Ошибка при создании графика');
            console.error(err);
        } finally {
            state.isLoading = false;
        }
    }, [state, crmID, workerPositionID, wpMode, messageApi, navigate, validateSchedule]);

    return { createSchedule };
}
